'use client';
import { createStyles } from '@s7/styles';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var useStyles = createStyles(function(theme, param) {
    var color = param.color;
    var _theme_fn = theme.fn, themeColor = _theme_fn.themeColor, primaryShade = _theme_fn.primaryShade;
    return {
        root: _extends({
            boxSizing: "border-box"
        }, color && {
            color: primaryShade(themeColor(color))
        })
    };
});

export { useStyles as default };
